import { Parse } from 'src/boot/parse'

export async function deeplTranslate(text, target, source) {
  // console.log('deeplTranslate', text, target, source)
  const res = await Parse.Cloud.run('translateText', {
    text, 
    targetLanguage: target, 
    // sourceLanguage: source,
  })
  // const langs = await Parse.Cloud.run('getSupportedLanguages')
  // console.log('langs', langs)
  const maped = res.map(el => el.text)
  // console.log('deeplTranslate res', maped)
  return maped
}

let fallbackBatchTranslator = async ({ texts, from, to }) => {

  const source = from === 'auto' ? undefined: from
  return await deeplTranslate(texts, to, source)
}


export function setFallbackBatchTranslator(fn) {
  fallbackBatchTranslator = fn; // async ({ texts, from, to }) => string[]
}

// TODO: fix Translator usage
// TODO: for unsupported pair use fallbackBatchTranslator
function isTranslatorAvailable() {
  // return typeof globalThis !== 'undefined'
  //   && typeof globalThis.Translator !== 'undefined'
  //   && typeof globalThis.Translator.create === 'function';
  return false
}

function isLanguageDetectorAvailable() {
  return typeof globalThis !== 'undefined'
    && typeof globalThis.LanguageDetector !== 'undefined'
    && typeof globalThis.LanguageDetector.create === 'function';
}

// Reuse instances
const translatorCache = new Map(); // key: `${from}::${to}` -> Promise<translator>
let detectorPromise = null;

async function getDetector() {
  if (!isLanguageDetectorAvailable()) return null;
  if (!detectorPromise) detectorPromise = globalThis.LanguageDetector.create();
  return detectorPromise;
}

async function detectLanguage(text, { minConfidence = 0.65 } = {}) {
  const detector = await getDetector();
  if (!detector) return null;

  const results = await detector.detect(text);
  if (!Array.isArray(results) || results.length === 0) return null;

  const best = results[0];
  if (!best?.detectedLanguage) return null;

  // cut by confidence
  if (typeof best.confidence === 'number' && best.confidence < minConfidence) return null;

  return best.detectedLanguage;
}

async function getTranslator(from, to) {
  if (!from) throw new Error('sourceLanguage is required');
  if (!to) throw new Error('targetLanguage is required');

  const key = `${from}::${to}`;
  if (!translatorCache.has(key)) {
    translatorCache.set(key, globalThis.Translator.create({
      sourceLanguage: from,
      targetLanguage: to
    }));
  }
  return translatorCache.get(key);
}

// --- micro-batch ---
let scheduled = false;
const queue = []; // { text, to, resolve, reject }

function scheduleFlush() {
  if (scheduled) return;
  scheduled = true;
  queueMicrotask(flush);
}

async function flush() {
  scheduled = false;
  if (!queue.length) return;

  const batch = queue.splice(0, queue.length);

  // Translator batch by pipeline
  try {
    // 1) If no Translator API — fallback
    console.log('is translator av', isTranslatorAvailable())
    if (!isTranslatorAvailable()) {
      if (fallbackBatchTranslator) {
        const texts = batch.map(j => j.text);

        const out = await fallbackBatchTranslator({ texts, from: 'auto', to: batch[0]?.to });
        batch.forEach((j, i) => j.resolve(out?.[i] ?? j.text));
      } else {
        batch.forEach(j => j.resolve(j.text));
      }
      return;
    }

    // 2) Detect lang
    for (const job of batch) {
      const text = job.text ?? '';
      const to = job.to;

      if (!text.trim() || !to) {
        job.resolve(text);
        continue;
      }

      let from = await detectLanguage(text);
      if (!from) {
        if (fallbackBatchTranslator) {
          const out = await fallbackBatchTranslator({ texts: [text], from: 'auto', to });
          job.resolve(out?.[0] ?? text);
        } else {
          job.resolve(text);
        }
        continue;
      }

      const translator = await getTranslator(from, to);
      const translated = await translator.translate(text);
      job.resolve(translated);
    }
  } catch (err) {
    batch.forEach(j => j.reject(err));
  }
}

export function translateText({ text, to }) {
  const safeText = (text ?? '').toString();
  return new Promise((resolve, reject) => {
    queue.push({ text: safeText, to, resolve, reject });
    scheduleFlush();
  });
}
